/**
 * TaskActivityFab
 * Floating action button that opens the activity drawer, badged with the number
 * of unread comments and notes across all the user's tasks.
 *
 * Hidden on the task detail route, where the page already has its own Comments
 * and Notes tabs and the drawer would compete with them.
 */

import { useLocation } from 'react-router-dom';
// Affix and Indicator have no equivalent in @/components — the rest of this
// component uses the library. Revisit if they are ever added there.
import { Affix, Indicator } from '@mantine/core';
import ActionIcon from '@/components/ui/ActionIcon';
import { IconMessages } from '@tabler/icons-react';
import { useTaskActivityStore } from '@/stores/taskActivityStore';

export function TaskActivityFab() {
  const location = useLocation();
  const totalUnread = useTaskActivityStore((s) => s.totalUnread);
  const drawerOpen = useTaskActivityStore((s) => s.drawerOpen);
  const setDrawerOpen = useTaskActivityStore((s) => s.setDrawerOpen);

  if (location.pathname.includes('/tasks/view/')) return null;
  if (drawerOpen) return null;

  return (
    <Affix position={{ bottom: 24, right: 24 }}>
      <Indicator
        label={totalUnread > 99 ? '99+' : totalUnread}
        size={18}
        disabled={totalUnread === 0}
        color="red"
        offset={4}
      >
        <ActionIcon
          size="xl"
          radius="xl"
          variant="filled"
          color="blue"
          aria-label={`Open activity${totalUnread > 0 ? ` (${totalUnread} unread)` : ''}`}
          onClick={() => setDrawerOpen(true)}
        >
          <IconMessages size={22} />
        </ActionIcon>
      </Indicator>
    </Affix>
  );
}
